/**
 * Demo site (Try Teamio) — what the frontend knows about a demo session. Plan Task 6.2 + decision 5a (2026-10-20),
 * `teamio-serverless-api` docs/plans/2026-10-02-demo-site-plan.md.
 *
 * A demo session is a Firebase custom token minted by demo-service (`/demo/redeem`, `/demo/switch-role`) with the
 * developer claims { demo: true, siteID: DEMO_SITE_ID, ... } and no `isCustomer`. The server decides what a demo
 * session may do (the layer's demoGuard); this flag only shapes the UI, so a forged flag gains nothing.
 *
 * ZERO imports on purpose: cypress/node-tests/demo-session.test.js executes this exact file via loadEsmUtil.
 */

/** demo-service lib/demoSiteSeed.js DEMO_SITE_ID — fixed, the same on dev and prod. */
export const DEMO_SITE_ID = 'de3d0000-0000-4000-8000-000000000001';

/**
 * localStorage hint so the FIRST paint after a reload already knows it is the demo. Never the source of truth:
 * firebase.config.js re-derives the flag from the ID token's claims on every boot.
 */
export const DEMO_SESSION_HINT_KEY = 'teamio_demo_session';

/** Where a demo session goes when it ends (it has no Microsoft or Google account to sign in with). */
export const DEMO_EXIT_PATH = '/try';

/** The page the operator's one-time link opens: `${APP_URL}/demo#t=<code>` (Task 6.3). */
export const DEMO_LANDING_PATH = '/demo';

/** sessionStorage: the link code kept in THIS tab while a real practice signs out first (used once by /demo). */
export const DEMO_PENDING_CODE_KEY = 'teamio_demo_pending_code';

/** sessionStorage: one-shot marker that a demo session just ended, so /try says so. */
export const DEMO_ENDED_KEY = 'teamio_demo_ended';

/** The one "Book a call" link (plan Task 6.4). */
export const BOOK_A_CALL_URL = 'https://calendar.app.google/gYs474EnvdUroyZAA';

/** Is this ID token a demo session? Only a real boolean `demo: true` on the demo site counts. */
export function isDemoClaims(claims) {
  return !!claims && claims.demo === true && claims.siteID === DEMO_SITE_ID;
}

/**
 * Where customer/logout lands. `next` may only be the exact landing path (the /demo "sign out of <Practice> first"
 * step); anything else is ignored, so logout can never be turned into an open redirect.
 */
export function logoutPath(isDemo, next) {
  if (next === DEMO_LANDING_PATH) return DEMO_LANDING_PATH;
  return isDemo === true ? DEMO_EXIT_PATH : '/login';
}
